export default {
  name: 'user-menu',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    isHeffronUser() {
      return this.$store.getters['auth/isHeffronUser'];
    },
    userName() {
      return `${this.$store.getters['auth/getUserGivenName']} ${this.$store.getters['auth/getUserFamilyName']}`;
    },
  },
  methods: {
    open() {
      if (this.isOpen) {
        return;
      }
      this.isOpen = true;
    },
    close() {
      if (!this.isOpen) {
        return;
      }
      this.isOpen = false;
    },
    handleSelect(item) {
      this.$emit('input', item);
      this.close();
    },
    signOut() {
      this.$store.dispatch('auth/signOut');
    },
  },
};
